import { styled, css } from "../../../../styles";

export const ModalContainer = styled("div", {
  height: "100%",
  width: "1120px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",

  padding: "24px 26px",

  fontFamily: "$openSans !important",

  "@media only screen and (max-width: 1250px) and (min-width: 768px)": {
    width: "768px",
  },

  "@media only screen and (max-width: 767px)": {
    width: "100%",
  },
});

export const SectionContainer = styled("div", {
  backgroundColor: "rgba(248, 248, 248, 0.8)",
  borderRadius: "8px",

  padding: "20px 21px",

  display: "flex",
  flexWrap: "wrap",

  p: {
    color: "#757575",
    fontSize: "14px",
    fontWeight: "500",
  },

  "@sm": {
    padding: "20px 12px 21px",
    p: {
      width: "0px",
    },
  },

  "@media(max-width:1100px)": {
    width: "700px",
  },

  variants: {
    isDevice: {
      true: {
        height: "98px !important",
        padding: "10px 21px !important",
        alignItems: "center",
        marginTop: "18px",

        overflowY: "visible",

        position: "relative",
      },
    },
  },
});

export const FormField = styled("div", {
  height: "42px",
  flexBasis: "50%",
  minWidth: "50%",

  marginBottom: "40px",

  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  padding: "0 30px 0 30px",
  position: "relative",

  outline: "none !important",

  ".ant-select-selection-placeholder": {
    color: "$gray-70 !important",
  },

  ".ant-select": {
    height: "42px !important",
  },

  p: {
    width: "155px",
    marginRight: "26px",

    color: "$charcoal",

    fontSize: "14px",
    lineHeight: "16px",
    fontFamily: "$openSans",
  },

  "@media only screen and (max-width: 1250px) and (min-width: 768px)": {
    flexBasis: "100%",
    minWidth: "100%",
  },

  variants: {
    isDevice: {
      true: {
        height: "100%",
      },
    },
  },
});

export const DatePickerInputConainer = styled("div", {
  width: "410px",
  height: "42px",

  backgroundColor: "$white",
  borderRadius: "6px",
  border: "2px solid $gray-50",

  display: "flex",
  alignItems: "center",

  paddingLeft: "11px",
  paddingRight: "11px",

  fontSize: "14px",
  fontWeight: "400",
  fontFamily: "$openSans",

  cursor: "pointer",

  svg: {
    width: "21px",
    height: "21px",

    marginLeft: "auto",
  },

  "&:hover": {
    border: "2px solid $primary-30",
  },

  "&:focus": {
    outline: "none !important",
    border: "2px solid #BDB4DD !important",
  },

  variants: {
    placeholder: {
      true: {
        color: "$gray-70",
      },
      false: {
        color: "$black",
      },
    },
  },
});

export const SubmitContainer = styled("div", {
  height: "70px",
  display: "flex",
  gap: "40px",
  padding: "26px 12px 0px 0px",
  alignItems: "center",
});

export const ErrorMessage = styled("p", {
  position: "absolute",

  fontSize: "12px !important",
  fontWeight: "600 !important",

  color: "$error-light !important",

  width: "max-content !important",
  bottom: -18,
  left: 240,

  "@media only screen and (max-width: 1250px) and (min-width: 768px)": {
    bottom: -18,
    left: 388,
  },

  variants: {
    isDevice: {
      true: {
        bottom: 0,
      },
    },
    isResponseError: {
      true: {
        position: "relative",
        width: "100% !important",
        whiteSpace: "normal",
        bottom: "auto",
        left: 0,
        marginTop: "20px",
        marginBottom: "16px",
      },
    },
  },
});

export const EnrolmentContainer = styled("div", {
  width: "100%",
  height: "100%",
  maxHeight: "580px",
  overflowY: "auto",
  paddingBottom: "24px",
});

export const AddDeviceButton = styled("div", {
  // EN-5191: was a fixed 146x32, sized around the English label. A longer translation
  // overflowed the width and the fixed height clipped the wrapped line. The minimums keep
  // the English button pixel-identical while a longer language grows instead of breaking.
  width: "max-content",
  minWidth: "146px",
  minHeight: "32px",
  whiteSpace: "nowrap",
  padding: "0 12px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",

  borderRadius: "8px",
  backgroundColor: "$black",

  color: "$white",
  fontFamily: "$openSans",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "22px",

  cursor: "pointer !important",

  marginTop: "30px",

  "&:hover": {
    backgroundColor: "$charcoal",
  },
});

export const CloseContainer = styled("div", {
  height: "16px",
  width: "16px",

  position: "absolute",

  top: "16px",
  right: "16px",

  zIndex: 3014,

  cursor: "pointer !important",

  svg: {
    cursor: "pointer !important",
    pointerEvents: "all",
  },
});

// CSS

export const inputCss = css({
  width: "248px",
  height: "42px",

  span: {
    margin: "0px",
  },

  p: {
    width: "100% !important",
  },

  input: {
    border: "2px solid $gray-50",
    borderRadius: "6px",
    paddingLeft: "11px",
    paddingRight: "11px",

    "&:hover": {
      border: "2px solid var(--colors-portal-text-input-border-hover)",
    },

    "&:focus": {
      border: "2px solid var(--colors-portal-text-input-border-focus)",
    },
  },
});

export const reactPhoneInputCss = css({
  width: "248px !important",
  height: "42px !important",
  zIndex: "2000",

  input: {
    border: "2px solid $gray-50 !important",
    borderRadius: "6px",
    paddingLeft: "11px",
    paddingRight: "11px",

    color: "$gray-90 !important",
    fontFamily: "$openSans !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    lineHeight: "22px !important",

    "&:hover": {
      borderColor: "var(--colors-portal-text-input-border-hover)!important",
    },

    "&:focus": {
      border:
        "2px solid var(--colors-portal-text-input-border-focus) !important",
    },
  },

  ".form-control": {
    width: "100% !important",
    height: "100% !important",

    "&:focus": {
      boxShadow: "none !important",
    },
  },

  ".open": {
    width: "100% !important",
    height: "100% !important",

    "&:focus": {
      boxShadow: "none !important",
    },
  },

  ".selected-flag": {
    "&::before": {
      borderColor: "transparent !important",
      boxShadow: "none !important",
    },
  },

  ".flag-dropdown": {
    ".country-list": {
      width: "248px !important",
      bottom: "40px !important",

      ".search": {
        ".search-box": {
          width: "218px",
          paddingTop: "5px",

          "&::placeholder": {
            color: "$gray-80",
          },
        },
      },

      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
});

export const dropdownCss = css({
  width: "248px !important",
  fontFamily: "$openSans",

  ".ant-select-selector": {
    border: "2px solid $gray-50 !important",
    borderRadius: "6px",
    alignItems: "center",
    ".ant-select-selection-search": {
      ".ant-select-selection-search-input": {
        fontFamily: "$openSans",
      },

      "&::placehholder": {
        fontFamily: "$openSans",
      },
    },
    ".ant-select-selection-overflow": {
      alignItems: "center",
      alignContent: "center",
    },
    ".ant-select-selection-placeholder": {
      alignSelf: "center",
    },
    "&:focus-within": {
      border:
        "2px solid var(--colors-portal-dropdown-selected-border) !important",
      boxShadow: "none !important",
    },

    "&:hover": {
      border:
        "2px solid var(--colors-portal-dropdown-selected-border) !important",
      boxShadow: "none !important",
    },
  },

  // Passing this class replaces SelectDropdown's internal selectCss, losing its arrow fix: antd
  // offsets the arrow with a negative margin sized for its own 12px icon, which leaves our 24px
  // ArrowDown off the selector's vertical midline. Re-centre it on the true middle.
  ".ant-select-arrow": {
    top: "50% !important",
    marginTop: "0 !important",
    transform: "translateY(-50%) !important",
  },

  // antd v5 multi-select top-aligns its content wrapper inside the selector;
  // re-center it so the placeholder/tags sit on the selector's vertical midline,
  // matching the single-select rendering in the same form. !important overrides
  // antd defaults that otherwise win on specificity grounds.
  "&.ant-select-multiple": {
    ".ant-select-selector": {
      alignItems: "center !important",
      display: "flex !important",
      minHeight: "42px !important",
    },
    ".ant-select-selection-wrap": {
      alignSelf: "center !important",
    },
    ".ant-select-selection-overflow": {
      alignItems: "center !important",
      alignSelf: "center !important",
    },
    ".ant-select-selection-placeholder": {
      position: "absolute !important",
      top: "50% !important",
      insetInlineStart: "11px !important",
      transform: "translateY(-50%) !important",
      margin: "0 !important",
      lineHeight: "1.5 !important",
      pointerEvents: "none",
    },
    ".ant-select-selection-search": {
      alignSelf: "center !important",
    },
  },

  "&:focus": {
    border:
      "2px solid var(--colors-portal-dropdown-selected-border) !important",
  },
});

export const dropdownPopUpCss = css({
  zIndex: 3001,
  pointerEvents: "auto",

  ".ant-select-item-option-selected": {
    backgroundColor:
      "var(--colors-portal-dropdown-popup-selected-background) !important",

    svg: {
      color: "$primary",
    },
  },

  ".ant-select-item-option-content": {
    fontFamily: "$openSans",
    color: "$black !important",
    fontWeight: "500 !important",
  },
  ".rc-virtual-list-holder": {
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
      borderRadius: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "$gray-50",
      borderRadius: "6px",
    },
  },
});
